'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = highlightText;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Zvýrazní text v řetězci.
 * @param search text pro zvýraznění
 * @param text řetězec
 * @return {*}
 */
function highlightText(search, text) {
    var searchLen = search.length;
    if (searchLen === 0) {
        return text;
    }

    var textLower = text.toLocaleLowerCase();
    var searchLower = search.toLocaleLowerCase();

    var arr = textLower.split(searchLower);
    var result = [];

    var i = 0;
    for (var a = 0; a < arr.length; a++) {
        var partLen = arr[a].length;
        if (partLen > 0) {
            result.push(text.substring(i, i + partLen));
            i += partLen;
        }
        result.push(_react2.default.createElement(
            'strong',
            null,
            text.substring(i, i + searchLen)
        ));
        i += searchLen;
    }

    return result;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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